import Vue from 'vue';
import Vue2Filters from 'vue2-filters';

Vue.use(Vue2Filters);

// Custom currency filter to display decimals only if value has cents
//  e.g.: 49.00 -> 49
//        49.99 -> 49.99
// Reusing 'Vue2Filters' currency filter
Vue.filter('currencyWithOptionalDecimal', (value, symbol = '$', decimalDigits = 2) => {
  const optionalDecimalDigits = Number.isInteger(Number(value)) ? 0 : decimalDigits;

  return Vue.options.filters.currency(value, symbol, optionalDecimalDigits);
});
